var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('b-form-checkbox',{on:{"change":_vm.save},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}}):_c('b-spinner',{attrs:{"small":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }